import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import Head from "../components/Head";

function Rates() {
  const tableRef = useRef(null);

  // Animation effect for form elements
  useEffect(() => {
    const animateFormElements = () => {
      const elements = document.querySelectorAll('.animate-in');

      elements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('show');
        }, 100 * index);
      });
    };

    // Run animation after a short delay
    setTimeout(animateFormElements, 200);
  }, []);

  useEffect(() => {
    // Initialize DataTable when component mounts
    let dataTable = null;

    const initializeDataTable = async () => {
      try {
        // Fetch rates data
        const response = await axios.get('data/rates.json');

        // Initialize DataTable with the fetched data
        if (tableRef.current && !$.fn.DataTable.isDataTable(tableRef.current)) {
          dataTable = $(tableRef.current).DataTable({
            data: response.data.data,
            columns: [
              { data: 'vehicle_type', title: 'Vehicle Type' },
              { data: 'make_and_model', title: 'Make & Model' },
              { data: 'number_of_passengers', title: '# of Passengers' },
              {
                data: 'hourly_rate',
                title: 'Hourly Rate',
                render: function (data) {
                  return `$${parseFloat(data).toFixed(2)}`;
                }
              },
              {
                data: 'additional_charges',
                title: 'Additional Charges',
                render: function (data) {
                  return `$${parseFloat(data).toFixed(2)}`;
                }
              }
            ],
            responsive: true,
            ordering: true,
            searching: true,
            paging: true,
            lengthMenu: [5, 10, 25, 50],
            pageLength: 10,
            dom: 'lfrtip'
          });
        }
      } catch (error) {
        console.error('Error fetching rates data:', error);
      }
    };

    initializeDataTable();

    // Clean up DataTable instance when component unmounts
    return () => {
      if (dataTable) {
        dataTable.destroy();
      }
    };
  }, []);

  return (
      <>
        <Head pageTitle="AMR - Rates" />
        <NavigationBar/>

        <style jsx="true">{`
            /* Animation styles */
            .animate-in {
                opacity: 0;
                transform: translateY(20px);
                transition: opacity 0.5s ease, transform 0.5s ease;
            }

            .animate-in.show {
                opacity: 1;
                transform: translateY(0);
            }
            
            th {
              color: #DBA800 !important;
            }
            
            .dt-length, .dt-search {
              display: unset;
            }
            
            .dt-search {
              float: right;
            }
            
            #ratesTable {
              margin-top: unset;
            }

            .dt-info {
              padding: 10px 0;
            }

            .card {
              border-radius: 15px;
              box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              transition: all 0.5s ease;
              border: none;
            }

            .card:hover {
              box-shadow: 0 5px 20px #DBA800;
            }

            @media (max-width: 768px) {
              .dt-search {
                float: left;
              }
            }
        `}</style>

        <section id="special" className="py-5 rates first-section">
          <div className="container">
            <div className="title text-center py-5 animate-in">
              <h2 className="position-relative d-inline-block">Rates</h2>
            </div>

            <div id="ratesTable" className="card special-list row g-0 animate-in">
              <div className="table-responsive">
                <table
                    id="rateTable"
                    ref={tableRef}
                    className="table table-striped"
                    style={{width: '100%'}}
                >
                  <thead>
                  <tr>
                    <th>Vehicle Type</th>
                    <th>Make & Model</th>
                    <th># of Passengers</th>
                    <th>Hourly Rate</th>
                    <th>Additional Charges</th>
                  </tr>
                  </thead>
                  <tbody>
                  {/* DataTables will populate this */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <Footer/>
      </>
  );
}

export default Rates;